import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AppService } from '../app.service';
// import { ApiService } from '../SmartReporter/sm-Services/api.service';
// import { LoginService } from '../SmartReporter/sm-Services/login.service';
// import { NotificationService } from '../SmartReporter/sm-Services/notification.service';
// import { TableauReportsService } from '../SmartReporter/sm-Services/tableau-reports.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { PageEvent } from '@angular/material/paginator';
import { HttpClient } from '@angular/common/http';
import Chart from 'chart.js/auto';
import { StandardUIService } from '../services/standardui-service/standardui-service';
import { AgentscriptService_updated } from '../services/agent-script-service/agent-script-service';
import { environment } from 'src/environments/environment';

interface ImageSR {
  src: string;
  alt: string;
  isActive: boolean;
  text:string;
  subtext:string;
}
interface allItem {
  src: string;  
  text:string;
  subtext:string;
  contenttext:string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translateX(0)',
      })),
      state('out', style({
        transform: 'translateX(100%)',
      })),
      transition('in => out', animate('300ms ease-out')),
      transition('out => in', animate('300ms ease-in')),
    ]),
  ],
})
export class HomeComponent implements OnInit {
  
  @Output() serviceTypeDetailsOutputEvent = new EventEmitter();

  slideState = 'in';
  Srboxes: any = [];
  userData: any;

  allItem: string[] = Array.from({ length: 30 }, (_, i) => `Item ${i + 1}`);
  pagedItems: allItem[] = [
    { src: '../../assets/images/bin.png',  text:'Bulk Trash Pickup', subtext:'5 hrs ago', 
    contenttext:'There is a day delay for the replacement of carts as they are under maintenance. '},
    { src: '../../assets/images/bin.png',  text:'Bulk Trash Pickup', subtext:'8 hrs ago', 
    contenttext:'There is a vehicle breakdown for the bulk trash pickup at '}

  ];
  pageSize = 2;
  pageSizeOptions: number[] = [2, 4, 6];
  totalItems = this.allItem.length;





  toggleSlide(): void {
    this.slideState = this.slideState === 'in' ? 'out' : 'in';
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.updatePagedItems();
    let n = event.pageIndex + 1;
    alert(JSON.stringify("Page Number to send to backend : " + n));
  }

  private updatePagedItems(): void {
    // const startIndex = this.pageSize * n;
    // this.pagedItems = this.items.slice(startIndex, startIndex + this.pageSize);
  }
  
  items = [
    { content: 'Toggle Box 1', isOpen: false },
    { content: 'Toggle Box 2', isOpen: false },
    // Add more items as needed
  ];

  toggleBoxf(index: number) {
    this.items[index].isOpen = !this.items[index].isOpen;
  }


// Srboxes: ImageSR[] = [
//     { src: '../../assets/images/bulk-trash.svg', alt: 'Bulk Trash Pickup', text:'Bulk Trash Pickup', subtext:'Solid Waste', isActive: false},
//     { src: '../../assets/images/garbage.svg', alt: 'Garbage',text:'Garbage' , subtext:'Solid Waste', isActive: false },
//     { src: '../../assets/images/CartMaintenance.svg', alt: 'Cart Maintenance',text:'Cart Maintenance',subtext:'Solid Waste',  isActive: false },
//     { src: '../../assets/images/LeafBagPickup.svg', alt: 'Leaf Bag Pickup', text:'Leaf Bag Pickup' ,subtext:'Streets', isActive: false},
//     { src: '../../assets/images/ServiceComplaint.svg', alt: 'Service Complaint',text:'Service Complaint' ,subtext:'Solid Waste', isActive: false },
//     { src: '../../assets/images/TallGrass.svg', alt: 'Tall Grass or Weeds',text:'Tall Grass or Weeds',subtext:'NCC',  isActive: false },
//     { src: '../../assets/images/recycle-bin.svg', alt: 'Recycling', text:'Recycling' ,subtext:'Solid Waste', isActive: false},
//     { src: '../../assets/images/street-lamp.svg', alt: 'Street Light Out',text:'Street Light Out' ,subtext:'Street Lighting', isActive: false },
//     { src: '../../assets/images/car.svg', alt: 'Abandoned Vehicle',text:'Abandoned Vehicle',subtext:'Parking Control',  isActive: false },
//     { src: '../../assets/images/Miscellaneous.svg', alt: 'Miscellaneous', text:'Miscellaneous' ,subtext:'Parking Control', isActive: false},
//     { src: '../../assets/images/Debris.svg', alt: 'Debris / Cistern',text:'Debris / Cistern' ,subtext:'NCC', isActive: false },
//     { src: '../../assets/images/car.svg', alt: 'Abandoned Vehicle',text:'Abandoned Vehicle',subtext:'NCC',  isActive: false }
//   ];

  toggleBox(srbox: ImageSR): void {
    console.log(srbox);
    this.Srboxes.forEach(b => b.isActive = (b === srbox) ? !b.isActive : false);
   
  }
  isClass = false;

  toggleClass() {
    this.isClass = !this.isClass;
  }

  site_name: string = "";
  site_id: string = "";
  auth_token: string = "";
  @Output() componentSelection = new EventEmitter<any>();
  constructor(private agentscriptservice: AgentscriptService_updated,private stnadardUiService:StandardUIService, private http: HttpClient,
    // private tableau_data: TableauReportsService, private appService: AppService, private _api: ApiService, private loginservice: LoginService, public notificationservice: NotificationService
  ) {
    // this.appService.pageTitle = 'Home';
  }
  public componentSelectionEmitter(componentData: object) {
    //console.log(componentData);
    this.componentSelection.emit(componentData);
  }
  ngOnInit(): void {
    this.stnadardUiService.castuserDetails.subscribe((data)=>{
      if(data){
        console.log(data);
        this.userData=data; 
      }
    })
    //this.userData=localStorage.getItem("role")
    let lookup = {};
    this.http.get<any>(environment.apiURL + 'getTrendingCasetypes').subscribe((trendingData) => {
      const newdata: any[] = Array.isArray(trendingData) ? trendingData : [];
      // Map trending API response directly to display format (no lookup - show all items from API)
      this.Srboxes = newdata.map((item: any) => ({
        ...item,
        content: item.casesubtypecontent || item.casetypecontent || '',
        imageUrl: item.casesubtypeimageurl || item.casetypeimageurl || '',
        alt: item.casesubtypecontent || item.casetypecontent || '',
        department: {
          id: item.departmentid,
          name: item.deptcontent || item.departmentidpicklist?.valueen || ''
        },
        division: item.divisionidpicklist ? { id: item.divisionid, name: item.divisionidpicklist.valueen } : null,
        isActive: false
      }));
    });

    


    this.updatePagedItems();
    //     localStorage.setItem("currentUser","2")
    //     localStorage.setItem("roletypeid","1")
    // console.log(localStorage.getItem("currentUser"));
    // console.log(localStorage.getItem('roletypeid'));
    // this.login();
    // this.loginservice.getuserdetails();
    // // this._api.getmapingFactData();
    // this._api.getUsers();
    // this._api.getGroups();
    // this._api.Getroletype();
    // this.notificationservice.getallnotifications();
    // this._api.getIfUserExistOrNot();
    //   this._api.getIfEmailExistOrNot();
  }
  gotoNext(componentData: any) {
    this.agentscriptservice.addtorecentservices(componentData.serviceDetails).subscribe((response)=>
      {
        console.log(response)
      })
    console.log(componentData)
    let v=componentData.id;
    if(isNaN(v)){
      v= v.replace(/\d+$/, '');
    }
    setTimeout(()=>{
      $('[data-link-id]').removeClass('link-active');      
      $('[data-link-id="'+v+'"]').addClass('link-active');     
    },200)
    this.componentSelection.emit(componentData)
  
  }
  login() {
    // this.tableau_data.login().subscribe(data => {
    //   if (data.credentials.site.contentUrl == "") {
    //     this.site_name = "Default"
    //   }
    //   else {
    //     this.site_name = data.credentials.site.contentUrl;
    //   }
    //   this.site_id = data.credentials.site.id;
    //   this.auth_token = data.credentials.token;
    //   this._api.site_id = data.credentials.site.id;
    //   this._api.auth_token = data.credentials.token;

    // })
  }

  chart: any;
  chartHeight:any;
  todaysServiceRequests:any;
  top5CaseTypes:any;
  totalNoofTodaysReq:any;
  backgroundColors: string[] = [];
  ngAfterViewInit() {
    
    this.stnadardUiService.getAllTodaysServiceRequest().subscribe((res)=>{      
      this.todaysServiceRequests = res;
      this.totalNoofTodaysReq = res[0].noofrequests;
    })
    this.stnadardUiService.getTop5Casetypes().subscribe((res)=>{
      this.backgroundColors = [
        'rgba(235, 100, 24, 1)',
        'rgba(248, 62, 62, 1)',
        'rgba(255, 255, 59, 1)',
        'rgba(72, 233, 72, 1)',
        'rgba(79, 79, 207, 1)'
      ];
      this.chartHeight = {
        // 'height':$('.doughnutchart').height() + 55 +'px',
        'width' : '200px'      
      }      
      this.top5CaseTypes = res;
      this.chart = new Chart('canvas', {
        type: this.top5CaseTypes.charttype,
     
        data: {         
          labels: this.top5CaseTypes.casetypelabel,
          datasets: [
            { 
              data: this.top5CaseTypes.values,
              backgroundColor: this.backgroundColors, 
            },
          ]
        },
        options: {   
          plugins: {
            legend: {
              display: false,
              position: 'right'
            }
          }
        }     
      });
    })
   

    
   }
  
}
